import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-sidebar',
  templateUrl: './filter-sidebar.component.html',
  styleUrls: ['./filter-sidebar.component.scss']
})
export class FilterSidebarComponent implements OnInit {

  @Output() filterStatus: EventEmitter<any> = new EventEmitter(); 	

  constructor() { }

  ngOnInit() {
  }

  closeFilterSidebar() {
  	this.filterStatus.emit({status: true, sidebarStatus: false});
  }	

}
